import { useChatDockStore } from './useChatDockStore';

/** Shape exposed to surfaces that drive the dock (e.g. a header toggle button). */
export interface ChatDockController {
  isOpen: boolean;
  toggle: () => void;
  /** Force-open the dock; always writes to localStorage even if already open. Prefer expand() for idempotent callers. */
  open: () => void;
  /** Open the dock if closed; no-op (and no localStorage write) if already open. */
  expand: () => void;
  /** Whether the dock is in its expanded (overlay) presentation. */
  expanded: boolean;
  /** Toggle the expanded (overlay) presentation; persists per active persistKey. */
  toggleExpanded: () => void;
}

/** Read/drive the dock from any surface (e.g. a header toggle button). */
export function useChatDockController(): ChatDockController {
  const isOpen = useChatDockStore((s) => s.open);
  const toggle = useChatDockStore((s) => s.toggle);
  const setOpen = useChatDockStore((s) => s.setOpen);
  const expand = useChatDockStore((s) => s.expand);
  const expanded = useChatDockStore((s) => s.expanded);
  const toggleExpanded = useChatDockStore((s) => s.toggleExpanded);
  return { isOpen, toggle, open: () => setOpen(true), expand, expanded, toggleExpanded };
}
